import axiosInstance from "../Interceptors/axiosInstance.jsx";

export const getAdvertisementBannersList = async () => {
  return await axiosInstance.get("advertisement-banners/getlist");
};

export const getAdvertisementBannerById = async (id) => {
  const response = await axiosInstance.get(`advertisement-banners/get/${id}`);
  return response.data.result;
};

export const addAdvertisementBanner = async (formData) => {
  return await axiosInstance.post("advertisement-banners/add", formData);
};

export const updateAdvertisementBanner = async (formData) => {
  return await axiosInstance.put("advertisement-banners/update", formData);
};

export const deleteAdvertisementBanner = async (id) => {
  return await axiosInstance.delete(`advertisement-banners/delete/${id}`);
};
